import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Flex,
  Input,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Text,
  Td,
  Button,
  Stack,
  FormControl,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { FaTrophy } from "react-icons/fa";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Student_reg_Table = () => {
  const toast = useToast();
  const [events, setEvents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [data, setData] = useState([]); // State to hold the fetched data
  const [prizes, setPrizes] = useState({}); // Store selected prize for each student
  const [categoryFilter, setCategoryFilter] = useState(""); // Filter for category
  const [subCategoryFilter, setSubCategoryFilter] = useState(""); // Filter for subcategory
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedEvent, setSelectedEvent] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const schoolId = sessionStorage.getItem("school_id"); // Replace with the appropriate `school_id`
  const [showRewarded, setShowRewarded] = useState(false);

  // Fetch data from the API when the component mounts
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/registration/list_reg.php`,
          {
            params: {
              school_id: sessionStorage.getItem("school_id"), // Get school_id
              teacher_id: sessionStorage.getItem("staff_id"), // Get teacher_id
            },
          }
        );
        console.log("listtt", response);

        if (response.data.success) {
          setData(response.data.data);

          // Initialize the prizes state with the fetched price_allocation
          const initialPrizes = response.data.data.reduce((acc, student) => {
            acc[student.id] = student.price_allocation; // Set the default prize for each student
            return acc;
          }, {});
          setPrizes(initialPrizes); // Set the prizes state
        } else {
          console.error("Failed to fetch data:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []); // Empty dependency array means this runs once when the component mounts

  const filteredData = data.filter((item) => {
    const matchesSearch = item.student_name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesEvent =
      selectedEvent === "" || item.event_title === selectedEvent;
    const matchesCategory =
      selectedCategory === "" || item.category === selectedCategory;
    const matchesSubCategory =
      selectedSubCategory === "" || item.sub_category === selectedSubCategory;
    const matchesRewardedFilter = !showRewarded || prizes[item.id];
    return (
      matchesSearch &&
      matchesEvent &&
      matchesCategory &&
      matchesSubCategory &&
      matchesRewardedFilter
    );
  });

  // Pagination logic
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const currentData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };
  useEffect(() => {
    // Fetch events
    const fetchEvents = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/event/list_all_event.php?school_id=${schoolId}`
        );
        setEvents(response.data.data.events || []);
      } catch (err) {
        console.error("Error fetching events:", err);
      }
    };

    // Fetch categories
    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/category/list_category.php?school_id=${schoolId}`
        );
        setCategories(response.data.data || []);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };

    // Fetch subcategories
    const fetchSubCategories = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/sub_category/list_subcat.php`,
          { params: { school_id: schoolId } }
        );
        console.log("r", response);

        setSubCategories(response.data.data || []);
      } catch (err) {
        console.error("Error fetching subcategories:", err);
      }
    };
    fetchEvents();
    fetchCategories();
    fetchSubCategories();
  }, [schoolId]);

  // Handle event filter
  const handleEventFilter = (e) => {
    const event = e.target.value;
    setSelectedEvent(event);

    // Filter categories based on selected event
    const categoriesForEvent = categories.filter(
      (category) => category.event_title === event
    );
    setFilteredCategories(categoriesForEvent);

    // Reset category and subcategory selections
    setSelectedCategory("");
    setSelectedSubCategory("");
    setFilteredSubCategories([]);
  };

  // Handle category filter
  const handleCategoryFilter = (e) => {
    const category = e.target.value;
    setSelectedCategory(category);

    // Filter sub-categories based on the selected category
    const subCategoriesForCategory = data
      .filter((student) => student.category === category)
      .map((student) => student.sub_category);
    setFilteredSubCategories(Array.from(new Set(subCategoriesForCategory)));
    setSelectedSubCategory(""); // Reset sub-category when category changes
  };

  // Handle subcategory filter
  const handleSubCategoryFilter = (e) => {
    setSelectedSubCategory(e.target.value);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when rows per page change
  };

  const handlePrizeChange = (studentId, prize) => {
    setPrizes((prevPrizes) => ({
      ...prevPrizes,
      [studentId]: prize, // Update the prize for this specific student
    }));
  };

  const handleAllocateClick = async (student) => {
    const prize = prizes[student.id];
    if (!prize) {
      toast({
        title: "No Prize Selected",
        description: "Please select a prize.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    setSelectedStudent(student);
    onOpen();

    // Send PUT request to allocate prize
    try {
      const response = await axios.put(
        `${BASE_URL}/admin/events/prize/add_prize.php`,
        {
          user_id: sessionStorage.getItem("user_id"), // Replace with the actual user_id
          school_id: sessionStorage.getItem("school_id"), // Replace with the actual school_id
          id: student.id, // Registration ID
          student_id: student.student_id, // Student ID
          price_allocation: prize, // Prize allocation value (1st, 2nd, 3rd)
        }
      );

      if (response.data.success) {
        toast({
          title: "Prize Allocated Successfully",
          description: "The prize has been allocated successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        onClose();
      } else {
        toast({
          title: "Failed to Allocate Prize",
          description: "Failed to allocate prize: " + response.data.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error allocating prize:", error);
      toast({
        title: "Error Allocating Prize",
        description: "An error occurred while allocating the prize.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  // Handler to toggle the rewarded filter
  const handleShowRewarded = () => {
    setShowRewarded(!showRewarded);
  };
  return (
    <Box>
      <Box ml={4} p={4}>
        <Flex
          direction={{ base: "column", md: "row" }} // Stack vertically on mobile, horizontally on larger screens
          justify="space-between"
          align="flex-start" // Align items to the start on mobile
          p={{ base: 2, md: 3 }} // Add responsive padding
          className="sb" // Ensure this class has the correct shadow styling
        >
          {/* Left Section: Rows Per Page Selector */}
          <Stack
            direction="column" // Stack vertically on mobile, horizontally on larger screens
            spacing={4}
            width="100%" // Ensure full width on mobile
            align="flex-start" // Align to the start on mobile
            mb={{ base: 3, md: 0 }} // Add margin on mobile for spacing
          >
            <Flex align="center" width="100%">
              <Select
                width={{ base: "100%", md: "120px" }} // Make Select take full width on mobile
                value={rowsPerPage}
                onChange={(e) => setRowsPerPage(Number(e.target.value))}
                borderColor="#E9EDF4"
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </Select>
            </Flex>
          </Stack>

          {/* Right Section: Category, Subcategory Filters and Search Input */}
          <Stack
            direction={{ base: "column", md: "row" }} // Stack vertically on mobile, horizontally on larger screens
            spacing={{ base: 4, md: 4 }} // Adjust spacing for mobile and larger screens
            width="100%" // Ensure full width on mobile
            align="flex-start"
          >
            {/* Event Filter */}
            <FormControl width="100%">
              <Select
                placeholder="Select Event"
                value={selectedEvent}
                onChange={handleEventFilter}
              >
                {events.map((event) => (
                  <option key={event.id} value={event.title}>
                    {event.event_title}
                  </option>
                ))}
              </Select>
            </FormControl>

            {/* Category Filter */}
            <FormControl width="100%" isDisabled={!selectedEvent}>
              <Select
                placeholder="Select Category"
                value={selectedCategory}
                onChange={handleCategoryFilter}
              >
                {filteredCategories.map((category) => (
                  <option key={category.id} value={category.name}>
                    {category.category}
                  </option>
                ))}
              </Select>
            </FormControl>

            {/* Sub-Category Filter */}
            <FormControl width="100%" isDisabled={!selectedCategory}>
              <Select
                placeholder="Select Sub-Category"
                value={selectedSubCategory}
                onChange={handleSubCategoryFilter}
              >
                {filteredSubCategories.map((subCategory) => (
                  <option key={subCategory} value={subCategory}>
                    {subCategory}
                  </option>
                ))}
              </Select>
            </FormControl>

            {/* Search Input */}
            <FormControl width="100%">
              <Input
                placeholder="Search by student name"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </FormControl>

            <Flex justify="space-between" align="center" >
              <Button
                onClick={handleShowRewarded}
                colorScheme={showRewarded ? "teal" : "gray"}
              >
                {showRewarded ? "Awarded Students" : "Reward "}
              </Button>
            </Flex>
          </Stack>
        </Flex>

        <Box overflowX="auto" maxWidth="100%">
          <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
            <Thead>
              <Tr>
                <Th>Name</Th>
                <Th>Category</Th>
                <Th>Subcategory</Th>
                <Th>Class</Th>
                <Th>Division</Th>
                <Th>Price Allocation</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.map((row, index) => (
                <Tr key={index}>
                  <Td>{row.student_name}</Td>
                  <Td>{row.category}</Td>
                  <Td>{row.sub_category}</Td>
                  <Td>{row.class}</Td>
                  <Td>{row.division}</Td>
                  <Td>
                    <Flex align="center" gap={2}>
                      <Select
                        placeholder="Select Prize"
                        onChange={(e) =>
                          handlePrizeChange(row.id, e.target.value)
                        }
                        value={prizes[row.id] || ""}
                        size="sm"
                        width="120px"
                      >
                        <option value="1">1st Prize</option>
                        <option value="2">2nd Prize</option>
                        <option value="3">3rd Prize</option>
                      </Select>
                      <Button
                        size="sm"
                        onClick={() => handleAllocateClick(row)}
                        disabled={!prizes[row.id]}
                        leftIcon={<FaTrophy />}
                        colorScheme="yellow"
                      >
                        Allocate
                      </Button>
                    </Flex>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>

        <Flex justify="end" align="center" p={3} className="sb2">
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            isDisabled={currentPage === 1}
          >
            Prev
          </Button>

          <Stack direction="row" spacing={2} mx={2}>
            {Array.from({ length: totalPages }, (_, i) => (
              <Button
                key={i}
                onClick={() => handlePageChange(i + 1)}
                colorScheme={currentPage === i + 1 ? "teal" : "gray"}
              >
                {i + 1}
              </Button>
            ))}
          </Stack>

          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            isDisabled={currentPage === totalPages}
          >
            Next
          </Button>
        </Flex>
      </Box>
      {/* Confirmation Modal */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirm Allocation</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            Are you sure you want to allocate the {prizes[selectedStudent?.id]}{" "}
            prize to <strong>{selectedStudent?.student_name}</strong>?
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleAllocateClick}>
              Yes
            </Button>
            <Button onClick={onClose}>No</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Student_reg_Table;
